import React, { createContext, useContext, useEffect } from "react";
import "./userPersona.css";
import "./mobilemenu.css";
import { Persona, PersonaSize } from "@fluentui/react";
import { Dropdown, Menu, Typography, Badge, Tooltip, notification } from "antd";
import Actions from "./Actions";
import { observer } from "mobx-react-lite";
import Media from "react-media";
import {
	LogoutOutlined,
	NotificationOutlined,
	SettingOutlined,
	UserOutlined,
} from "@ant-design/icons";
import { getCurrentUser } from "../../../../Utility/modules/helpers";
import ProfileStore from "../../../userprofile/store/profilestore";
import { useNavigate } from "react-router-dom";
import { HelpCircle, Settings, Youtube } from "react-feather";
import MainStore from "../../store/mainStore";
import RequestStore from "../../../productiondata/approvals/store/requeststore";

const requestStoreCtx = createContext(RequestStore);
const mainstore = createContext(MainStore);
const { Text } = Typography;

export const UserPersona = observer(() => {
	const requestStore = useContext(requestStoreCtx);
	const profileStore = useContext(ProfileStore);
	const mainStore = useContext(mainstore);
	const navigate = useNavigate();
	const currentUser = getCurrentUser();

	useEffect(() => {
		if (currentUser?.id) {
			requestStore.loadMyApprovals(currentUser.id).catch((error) => {
				notification.error({
					message: "SPARS Feedback Manager",
					description: error.message,
				});
			});
		}
	}, [currentUser?.id, requestStore]);

	const logOut = () => {
		window.currentUser = undefined;
		navigate("/login");
	};

	const menuHeaderDropdown = (
		<Menu>
			<Menu.Item
				key="center"
				onClick={() => {
					navigate("/main/userprofile/settings");
					profileStore.selectKey = "3";
				}}
			>
				<UserOutlined /> <Text>My Privileges</Text>
			</Menu.Item>
			<Menu.Item
				key="settings"
				onClick={() => {
					navigate("/main/userprofile/settings");
					profileStore.selectKey = "1";
				}}
			>
				<SettingOutlined /> <Text>My Profile Settings</Text>
			</Menu.Item>
			<Menu.Divider />
			<Menu.Item key="logout" onClick={logOut}>
				<LogoutOutlined /> <Text>Logout</Text>
			</Menu.Item>
		</Menu>
	);

	return (
		<Media query={{ minWidth: 1024 }}>
			{(matches) =>
				matches ? (
					<div className="ms-Grid-col ms-sm3" style={{ cursor: "pointer" }}>
						<div className="ms-Grid" dir="ltr">
							<div className="ms-Grid-row">
								<div className="ms-Grid-col ms-sm2 light-border notification">
									<Actions />
								</div>
								<div className="ms-Grid-col ms-sm2 top-menu-buttons">
									<Tooltip title="User Preference">
										<Settings
											color="white"
											size="18"
											onClick={() => {
												mainStore.showSettingsDialog = true;
											}}
										/>
									</Tooltip>
								</div>
								<div className="ms-Grid-col ms-sm2 top-menu-buttons">
									<Tooltip title="SPARS Support">
										<HelpCircle
											color="white"
											size="18"
											onClick={() =>
												notification.info({
													message: "SPARS Feature Feedback",
													description: "This feature is coming soon in the next deployment",
													placement: "bottomRight",
												})
											}
										/>
									</Tooltip>
								</div>
								<div className="ms-Grid-col ms-sm2 top-menu-buttons">
									<Tooltip title="Feedback or Feature request">
										<i className="ms-Icon ms-Icon--Feedback" aria-hidden="true" />
									</Tooltip>
								</div>
								<div className="ms-Grid-col ms-sm2 top-menu-buttons">
									<Tooltip title="SPARS Training/Guides">
										<Youtube
											color="white"
											size="18"
											onClick={() =>
												notification.info({
													message: "SPARS Feature Feedback",
													description: "This feature is coming soon in the next deployment",
													placement: "bottomRight",
												})
											}
										/>
									</Tooltip>
								</div>
								<div className="ms-Grid-col ms-sm2 persona light-border">
									<Tooltip title={currentUser?.fullName} placement="right">
										<Dropdown overlay={menuHeaderDropdown} trigger={["click"]}>
											<span>
												<Persona
													size={PersonaSize.size40}
													text={currentUser?.fullName}
													hidePersonaDetails
												/>
											</span>
										</Dropdown>
									</Tooltip>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="ms-Grid-col ms-sm2 notification">
						<Badge
							count={requestStore.myApprovals.size}
							style={{ cursor: "pointer", boxShadow: "0 0 0 1px red" }}
						>
							<NotificationOutlined />
						</Badge>
					</div>
				)
			}
		</Media>
	);
});
